// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { WorkflowAnswerOption } from './workflowAnswerOption';

/**
 * Serializer for validating WorkflowResponseQuestion.
 * @see #/components/schemas/WorkflowQuestionnaireQuestion - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface WorkflowQuestionnaireQuestion {
    /**
     * The identifier of Question-ID.
     *
     */
    id: string;
    /**
     * The title of the Workflow-Item-Answer.
     *
     */
    title?: string | null;
    /**
     * The description of the Workflow-Item-Answer.
     *
     */
    description?: string | null;
    /**
     * The type of Item Questionnaire.
     *
     */
    item_type: string;
    /**
     * The current value of the Workflow-Item-Answer.
     *
     */
    current_value?: string | null;
    /**
     * The answer suggestion of Workflow-Item-Answer.
     *
     */
    answer_suggestion?: WorkflowAnswerOption | null;
    /**
     * The answer options of Workflow-Item-Answer.
     *
     */
    answer_options?: Array<WorkflowAnswerOption> | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for WorkflowQuestionnaireQuestion
 */
export namespace WorkflowQuestionnaireQuestion {
    /**
     * WorkflowQuestionnaireQuestion Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The identifier of Question-ID.
         * @type string (`dataFormat` is missing)
         */
        id: string;
        /**
         * The title of the Workflow-Item-Answer.
         * @type string (`dataFormat` is missing)
         */
        title?: string | null;
        /**
         * The description of the Workflow-Item-Answer.
         * @type string (`dataFormat` is missing)
         */
        description?: string | null;
        /**
         * The type of Item Questionnaire.
         * @type string (`dataFormat` is missing)
         */
        itemType: string;
        /**
         * The current value of the Workflow-Item-Answer.
         * @type string (`dataFormat` is missing)
         */
        currentValue?: string | null;
        /**
         * The answer suggestion of Workflow-Item-Answer.
         * @type WorkflowAnswerOption (`dataFormat` is missing)
         */
        @Type(() => WorkflowAnswerOption.Model) answerSuggestion?: WorkflowAnswerOption.Model | null;
        /**
         * The answer options of Workflow-Item-Answer.
         * @type Array<WorkflowAnswerOption> (`dataFormat` is missing)
         */
        @Type(() => WorkflowAnswerOption.Model) answerOptions?: Array<WorkflowAnswerOption.Model> | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * WorkflowQuestionnaireQuestion DTO
     * Transforms WorkflowQuestionnaireQuestion model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend WorkflowQuestionnaireQuestion model */
        static toModel(obj: WorkflowQuestionnaireQuestion): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend WorkflowQuestionnaireQuestion model */
        static toApi(obj: Model): WorkflowQuestionnaireQuestion {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as WorkflowQuestionnaireQuestion;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
